<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav v-bind:gray="gray" v-bind:pos="'fixed'"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <div class="topWrp clear">
        <div class="txt">
          <h1>
            Your {{ tenant != "" ? tenant.toUpperCase() : "UNIFI" }} invoices
          </h1>
          <h2>
            When the status of one of your clients properties changes, we will
            notify you here that it is time to send us an invoice for your
            commission.
          </h2>
        </div>
        <div class="more">
          <h3>Direct all invoices to:</h3>
          <h4>{{ tenant != "" ? tenant.toUpperCase() : "UNIFI" }}</h4>
          <a target="_blank" v-bind:href="'mailto:' + contactEmail">{{
            contactEmail
          }}</a>
        </div>
      </div>
      <div class="botWrp">
        <div class="tit clear">
          <h6
            :class="[tenantClassCur(pos, 0), tenantClass(pos, 0)]"
            @click="change(0)"
          >
            Due invoices
          </h6>
          <h6
            :class="[tenantClassCur(pos, 1), tenantClass(pos, 1)]"
            @click="change(1)"
          >
            Past invoices
          </h6>
          <!--<h6 :class="{cur:pos == 2}" @click="change(2)">Receipts</h6>-->
        </div>
        <div class="subtit">
          <p v-if="pos == 0">
            Please send
            {{ tenant != "" ? tenant.toUpperCase() : "UNIFI" }} invoices for the
            following properties.
          </p>
          <p v-if="pos == 1">
            Below is a list of past invoices you have sent to UNIFI.
          </p>
        </div>
        <div v-if="pos == 0" class="boxs">
          <div v-for="(item, index) in dueLst" :key="index" class="box clear">
            <div class="lft">
              <div class="date">Send now - {{ item.time }}:</div>
              <div v-if="item.invoiceName !== ''" class="tip">
                {{ item.invoiceName }}
              </div>
              <div class="number">#{{ item.invoiceId }}</div>
              <div v-if="item.invoiceType !== 'bound'" class="more">
                <span>property:</span>{{ item.property }}
              </div>
            </div>
            <div class="rgt">
              <div class="txt">${{ item.total }}</div>
              <div class="clear">
                <button
                  :class="{ disabled: item.doneFlag == 'yes' }"
                  :disabled="item.doneFlag == 'yes'"
                  @click="mark(item.id, item.doneFlag, 'due')"
                >
                  Invoice Sent
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="
              due.totalRecord > 0 &&
                due.totalRecord !== dueLst.length &&
                !loadingDue
            "
            class="loadMore"
            @click="loadDue"
          >
            Load More
          </div>
          <div v-if="loadingDue" class="loading">
            loading<i class="el-icon-loading"></i>
          </div>
        </div>
        <div v-if="pos == 1" class="boxs">
          <div v-for="(item, index) in passLst" :key="index" class="box clear">
            <div class="lft">
              <div class="date">Send now - {{ item.time }}:</div>
              <div v-if="item.invoiceName !== ''" class="tip">
                {{ item.invoiceName }}
              </div>
              <div class="number">#{{ item.invoiceId }}</div>
              <div v-if="item.invoiceType !== 'bound'" class="more">
                <span>property:</span>{{ item.property }}
              </div>
            </div>
            <div class="rgt">
              <div class="txt">${{ item.total }}</div>
              <div class="clear">
                <button
                  :class="{ disabled: item.doneFlag == 'yes' }"
                  :disabled="item.doneFlag == 'yes'"
                  @click="mark(item.id, item.doneFlag, 'pass')"
                >
                  Invoice sent
                </button>
              </div>
            </div>
          </div>
          <div
            v-if="
              pass.totalRecord > 0 &&
                pass.totalRecord !== passLst.length &&
                !loadingPass
            "
            class="loadMore"
            @click="loadPass"
          >
            Load More
          </div>
          <div v-if="loadingPass" class="loading">
            loading<i class="el-icon-loading"></i>
          </div>
        </div>
        <!--<div class="boxs" v-if="pos == 2">
            <div class="box clear" v-for="(item, index) in pdfLst" :key="index">
                <div class="lft">
                    <div class="date">Send now - {{item.time}}:</div>
                    <div class="tip">Receipts</div>
                    <div class="number">#{{item.invoiceId}}</div>
                    <div class="more"><span>property:</span>{{item.property}}</div>
                </div>
                <div class="rgt">
                    <div class="clear">
                        <a target="_blank" :href="item.depositPdf" style="margin-top: 60px;">View</a>
                    </div>
                </div>
            </div>
            <div class="loadMore" v-if="pdf.totalRecord > 0 && pdf.totalRecord !== pdfLst.length && !loadingPdf"
            @click="loadPdf">Load More</div>
            <div class="loading" v-if="loadingPdf">loading<i class="el-icon-loading"></i></div>
        </div>-->
      </div>
    </div>
    <!--footer -->
    <foot-nav></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions, mapMutations, mapState } from "vuex";

export default {
  data() {
    return {
      gray: true,
      pos: 0,
      duePage: 1,
      passPage: 1,
      pdfPage: 1,
      loadingDue: true,
      loadingPass: true,
      loadingPdf: true,
      contactEmail: "",
      tenant: window.location.hostname
        .replace("m.", "")
        .split(".")[0]
        .split("testunifiproperty")[0]
        .split("unifiproperty")[0]
        .split("platform")[0]
    };
  },
  created() {
    var that = this;
    that.getDueLst({
      params: { page: 1, pageSize: 10, type: 1 },
      callback: that.dueCallback
    });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("invoice", [
      "getDueLst",
      "getPassLst",
      "getPdfLst",
      "markPut"
    ]),
    ...mapMutations("invoice", [
      "setDueLst",
      "setPassLst",
      "setPdfLst",
      "updateMark"
    ]),
    ...mapMutations("login", ["setNumber"]),
    mark(id, flag, type) {
      var that = this;
      that.$box.loadings();
      if (flag == "yes") {
        return;
      }
      if (type == "due")
        that.markPut({ params: id, callback: that.markCallback });
      else that.markPut({ params: id, callback: that.passMarkCallback });
    },
    loadDue() {
      var that = this;
      that.duePage++;
      that.loadingDue = true;
      that.getDueLst({
        params: { page: that.duePage, pageSize: 10 },
        callback: that.dueCallback
      });
    },
    loadPass() {
      var that = this;
      that.passPage++;
      that.loadingPass = true;
      that.getPassLst({
        params: { page: that.passPage, pageSize: 10 },
        callback: that.passCallback
      });
    },
    loadPdf() {
      var that = this;
      that.pdfPage++;
      that.loadingPdf = true;
      that.getPdfLst({
        params: { page: that.passPage, pageSize: 10 },
        callback: that.pdfCallback
      });
    },
    dueCallback(res, type) {
      var that = this;
      if (res.data.code == 0) {
        that.loadingDue = false;
        res.data.data.invoicePagePojo.list.forEach(v => {
          v.total = that.$box.formatSplit(v.total, false);
          v.time = that.$box.formatTimestampLL(v.createTime);
        });
        that.contactEmail = res.data.data.contactEmail;
        if (type && type == 1) {
          that.setDueLst({ data: res.data.data.invoicePagePojo, type: 1 });
        } else {
          that.setDueLst({ data: res.data.data.invoicePagePojo });
        }
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    passCallback(res, type) {
      var that = this;
      if (res.data.code == 0) {
        that.loadingPass = false;
        res.data.data.invoicePagePojo.list.forEach(v => {
          v.total = that.$box.formatSplit(v.total, false);
          v.time = that.$box.formatTimestampLL(v.createTime);
        });
        that.contactEmail = res.data.data.contactEmail;
        if (type && type == 1) {
          that.setPassLst({ data: res.data.data.invoicePagePojo, type: 1 });
        } else {
          that.setPassLst({ data: res.data.data.invoicePagePojo });
        }
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    pdfCallback(res, type) {
      var that = this;
      if (res.data.code == 0) {
        that.loadingPdf = false;
        res.data.data.list.forEach(v => {
          v.total = that.$box.formatSplit(v.total, false);
          v.time = that.$box.formatTimestampLL(v.createTime);
        });
        if (type && type == 1) {
          that.setPdfLst({ data: res.data.data, type: 1 });
        } else {
          that.setPdfLst({ data: res.data.data });
        }
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    markCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.$box.loadings(2);
        that.setNumber({ number: res.data.data.unReadNumers });
        that.updateMark({ id: res.data.data.userInvoice.id, type: "due" });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    passMarkCallback(res) {
      var that = this;
      if (res.data.code == 0) {
        that.setNumber({ number: res.data.data.unReadNumers });
        that.updateMark({ id: res.data.data.userInvoice.id, type: "pass" });
      } else if (res.data.code == 90000 || res.data.code == 90002) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    },
    change(e) {
      var that = this;
      that.pos = e;
      if (e == 1) {
        that.getPassLst({
          params: { page: 1, pageSize: 10, type: 1 },
          callback: that.passCallback
        });
      } else if (e == 0) {
        that.getDueLst({
          params: { page: 1, pageSize: 10, type: 1 },
          callback: that.dueCallback
        });
      } else if (e == 2) {
        that.getPdfLst({
          params: { page: 1, pageSize: 10, type: 1 },
          callback: that.pdfCallback
        });
      }
    },
    tenantClassCur(pos, posValue) {
      let className = "";
      if (pos == posValue) {
        className = "cur";
      }
      return className;
    },
    tenantClass(pos, posValue) {
      let className = "";
      if (pos == posValue) {
        className = "tenant-" + this.tenant;
      }
      return className;
    }
  },
  components: {
    headNav,
    footNav
  },
  computed: {
    ...mapState({
      due: state => state.invoice.due,
      dueLst: state => state.invoice.dueLst,
      pass: state => state.invoice.pass,
      passLst: state => state.invoice.passLst,
      pdf: state => state.invoice.pdf,
      pdfLst: state => state.invoice.pdfLst
    })
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  padding: 0 0.28rem;
  padding-top: 1.52rem;
  box-sizing: border-box;

  .topWrp {
    margin-bottom: 0.8rem;

    h1 {
      font-size: 0.56rem;
      color: #2a2929;
      line-height: 0.68rem;
      font-family: ProximaNova-Semibold;
    }

    h2 {
      font-size: 0.28rem;
      line-height: 0.42rem;
      margin: 0.32rem 0 0.8rem 0;
      color: #3f3f46;
      word-break: break-word;
    }

    .txt {
      width: 100%;
      float: left;
    }

    .more {
      width: 100%;
      height: 2.74rem;
      background: rgba(245, 245, 247, 1);
      border-radius: 3px;
      float: right;
      box-sizing: border-box;
      padding: 0.48rem 0.32rem;

      h3 {
        font-size: 0.28rem;
        line-height: 0.34rem;
        margin-bottom: 0.32rem;
        color: #7f7d80;
      }

      h4 {
        font-size: 0.36rem;
        line-height: 0.44rem;
        margin-bottom: 0.32rem;
        color: #2a2929;
        font-family: ProximaNova-Semibold;
      }

      a {
        font-size: 0.3rem;
        line-height: 0.36rem;
        font-family: ProximaNova-Semibold;
        text-decoration: underline;
        color: #0391ff;
      }
    }
  }

  .botWrp {
    width: 100%;
    margin: 0 auto 56px auto;

    .tit {
      width: 100%;
      margin: 0 auto 0.48rem auto;
      display: flex;
      padding: 0 0.2rem;
      box-sizing: border-box;

      h6 {
        flex: 1;
        text-align: center;
        position: relative;
        color: #7f7d80;
        font-size: 0.32rem;
        line-height: 0.38rem;
        float: left;
        cursor: pointer;
      }

      h6:nth-last-child(1) {
        margin: 0;
      }

      .cur {
        color: #2a2929;
        font-family: ProximaNova-Semibold;
      }

      .cur:after {
        content: "";
        display: block;
        width: 100%;
        bottom: -0.2rem;
        left: 0;
        height: 0.08rem;
        //background: #ffef00;
        position: absolute;
      }
    }

    p {
      font-size: 0.28rem;
      line-height: 0.54rem;
      margin-bottom: 0.48rem;
      text-align: center;
      color: #2a2929;
    }

    .boxs {
      margin-bottom: 0.82rem;
      box-sizing: border-box;

      .box {
        padding: 0.48rem 0.32rem;
        background: rgba(255, 255, 255, 1);
        border-radius: 3px;
        border: 1px solid rgba(223, 223, 223, 1);
        box-sizing: border-box;
        margin-bottom: 24px;

        .lft {
          width: 100%;
          position: relative;

          .date {
            font-size: 0.28rem;
            line-height: 0.34rem;
            color: #7f7d80;
            margin-bottom: 0.32rem;
          }

          .tip {
            font-size: 0.42rem;
            line-height: 0.5rem;
            margin-bottom: 0.16rem;
            color: #2a2929;
            font-family: ProximaNova-Semibold;
          }

          .number {
            font-size: 0.3rem;
            line-height: 0.36rem;
            margin-bottom: 0.32rem;
            color: #333333;
          }

          .more {
            font-size: 0.3rem;
            line-height: 0.44rem;
            color: #333333;

            span {
              color: #7f7d80;
              margin-right: 0.32rem;
            }
          }
        }

        .lft:after {
          content: "";
          position: absolute;
          bottom: -0.32rem;
          right: 0;
          width: 100%;
          height: 1px;
          background: rgba(223, 223, 223, 1);
        }

        .rgt {
          display: block;

          .txt {
            font-size: 0.4rem;
            line-height: 0.48rem;
            padding-top: 0.82rem;
            color: #7d7a7d;
            font-family: ProximaNova-Semibold;
            margin-bottom: 0.48rem;
            text-align: center;
          }

          button,
          a {
            border: none;
            display: block;
            margin: 0 auto;
            width: 4.8rem;
            height: 0.92rem;
            background: rgba(44, 202, 115, 1);
            border-radius: 6px;
            line-height: 0.92rem;
            font-size: 0.3rem;
            font-family: ProximaNova-Semibold;
            text-align: center;
            color: #fff;
            cursor: pointer;
          }

          .disabled {
            background: #a2e3c2;
            cursor: not-allowed;
          }
        }
      }

      .loadMore {
        cursor: pointer;
        width: 100px;
        margin: 0 auto;
        text-align: center;
        text-decoration: underline;
        font-size: 14px;
        padding-top: 20px;
      }

      .loading {
        cursor: pointer;
        width: 100px;
        margin: 0 auto;
        text-align: center;
        font-size: 18px;
        padding-top: 20px;

        i {
          margin-left: 10px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/account/invoice.vue